import { createFileRoute } from '@tanstack/react-router';

import { DriversViewPage } from '@/areas/manufacturing-templates/Drivers/DriversView/DriversViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar/drivers/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <DriversViewPage />;
}
